<template>
    <div class="home">
        <!--表单部分-->
        <div class="form-wrapper">
            <!--头像-->
            <div class="form-item no-flex">
                <label>头像</label>
                <div class="upload-area">
                    <UploadImg
                        :index="1"
                        :multiple="false"
                        :limit="1"
                        :imgurl="headImg"
                        :headers="headers"
                        @success="success"
                        @remove="remove" />
                </div>
            </div>

            <!-- 手机号 -->
            <div class="form-item no-flex">
                <label>手机号</label>
                <div class="phone">{{userInfo.cellphone}} </div>
            </div>

            <!--昵称-->
            <div class="form-item">
                <label>昵称</label>
                <div class="input-box">
                    <el-input v-model="username" placeholder="昵称"></el-input>
                </div>
            </div>
            <!--保存-->
            <div class="btns">
                <el-button @click="save" size="medium" type="primary">确定</el-button>
            </div>
        </div>
        <RequestLoading :show="show" />
    </div>
</template>

<script>
    import {mapGetters,mapMutations,mapActions} from 'vuex';
    import HeaderBar from '@/components/layout/HeaderBar';
    import UploadImg from '@/components/tool/UploadImg';
    import RequestLoading from '@/components/tool/RequestLoading';
    import {editUser} from '@/services/login';
    import {strValidate} from '@/assets/js/tool';

    export default {
        name: "UserInfo",
        components: {
            HeaderBar,
            UploadImg,
            RequestLoading,
        },
        computed: {
            headers() {
                return {
                    token: this.userInfo.token,
                    userid: this.userInfo.userid
                };
            },
            ...mapGetters(['userInfo'])
        },
        data() {
            return{
                collapse: false,
                show: false,
                username: '',
                headImg: '',
            };
        },
        created() {
            // this.RESET_AUTH();
        },
        methods: {
            //成功上传照片
            success(obj) {
                this.headImg = obj.url;
                console.log(this.headImg)
            },      
            //移除照片
            remove(obj) {
                this.headImg = '';

            },

            //点击保存
            save() {
                //发送数据
                let data = {
                    userid: this.userInfo.userid
                };

                //昵称
                let username = strValidate(this.username, '昵称', false, 2, 30);
                data.username = username;

                //头像
                data.headImg = this.headImg;

                //发送数据到服务器
                this.sendData(data);
            },
            //发送数据到服务器
            async sendData(data) {
                try {
                    this.show = true;
                    await editUser(data);
                    this.show = false;
                    //操作成功
                    this.msg('操作成功', 4);
                    setTimeout(() => {
                        this.$router.push({
                            name: 'AppList'
                        });
                    }, 500);
                } catch(err) {
                    this.show = false;
                    this.msg(err, 3);
                }
            },
        }
    }
</script>

<style scoped>
img {
    width: 100%;
}
.applyList {
    width: 94%;
    margin: auto;
}
.form-item label {
    width: 20%;
}
.upload-area {
    margin-left: 10px;
}
.phone {
    margin-left: 12px;
}
</style>